import { createReducer } from 'deox';
import produce from 'immer';
import { OrdersState } from './types';
import {
  getOrdersAction,
  getOrderByIdAction,
  createOrderAction,
  deleteOrderAction,
  commitOrderAction,
  // addItemsAction,
  getOrderItemAction,
  updateOrderItemAction,
  deleteOrderItemAction,
} from './actions';

const initialState: OrdersState = {
  isLoading: {
    list: false,
    single: false,
    create: false,
    delete: false,
    commit: false,
    addItems: false,
    updateItem: false,
    deleteItem: false,
  },
  errors: {
    list: null,
    single: null,
    create: null,
    delete: null,
    commit: null,
    addItems: null,
    updateItem: null,
    deleteItem: null,
  },
  list: null,
  currentOrder: null,
};

export const ordersReducer = createReducer(initialState, handle => [
  // Получение списка заказов
  handle(getOrdersAction.request, state =>
    produce(state, draft => {
      draft.isLoading.list = true;
      draft.errors.list = null;
    }),
  ),
  handle(getOrdersAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = null;
      draft.list = payload;
    }),
  ),
  handle(getOrdersAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = payload;
    }),
  ),

  // Получение одного заказа
  handle(getOrderByIdAction.request, state =>
    produce(state, draft => {
      draft.isLoading.single = true;
      draft.errors.single = null;
    }),
  ),
  handle(getOrderByIdAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = null;
      draft.currentOrder = payload;
    }),
  ),
  handle(getOrderByIdAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = payload;
    }),
  ),

  // Создание заказа
  handle(createOrderAction.request, state =>
    produce(state, draft => {
      draft.isLoading.create = true;
      draft.errors.create = null;
    }),
  ),
  handle(createOrderAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.create = false;
      draft.errors.create = null;
      if (draft.list) {
        draft.list.push(payload); // добавляем новый заказ в список
      } else {
        draft.list = [payload];
      }
    }),
  ),
  handle(createOrderAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.create = false;
      draft.errors.create = payload;
    }),
  ),

  // Удаление заказа
  handle(deleteOrderAction.request, state =>
    produce(state, draft => {
      draft.isLoading.delete = true;
      draft.errors.delete = null;
    }),
  ),
  handle(deleteOrderAction.success, (state, { payload: id }) =>
    produce(state, draft => {
      draft.isLoading.delete = false;
      draft.errors.delete = null;
      if (draft.list) {
        draft.list = draft.list.filter(order => order.pk !== id);
      }
    }),
  ),
  handle(deleteOrderAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.delete = false;
      draft.errors.delete = payload;
    }),
  ),

  // Коммит заказа
  handle(commitOrderAction.request, state =>
    produce(state, draft => {
      draft.isLoading.commit = true;
      draft.errors.commit = null;
    }),
  ),
  handle(commitOrderAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.commit = false;
      draft.errors.commit = null;
      // обновляем текущий заказ, если был закоммичен
      draft.currentOrder = payload;
    }),
  ),
  handle(commitOrderAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.commit = false;
      draft.errors.commit = payload;
    }),
  ),

  // Добавление товаров в заказ
  // handle(addItemsAction.request, state =>
  //   produce(state, draft => {
  //     draft.isLoading.addItems = true;
  //     draft.errors.addItems = null;
  //   }),
  // ),
  // handle(addItemsAction.success, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.isLoading.addItems = false;
  //     draft.errors.addItems = null;
  //     // обновляем текущий заказ с новыми товарами
  //     draft.currentOrder = payload;
  //   }),
  // ),
  // handle(addItemsAction.failure, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.isLoading.addItems = false;
  //     draft.errors.addItems = payload;
  //   }),
  // ),

  // Получение товара по ID
  handle(getOrderItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.single = true;
      draft.errors.single = null;
    }),
  ),
  handle(getOrderItemAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = null;
      // обновляем текущий товар в текущем заказе
      if (draft.currentOrder) {
        const itemIndex = draft.currentOrder.order_items.findIndex(item => item.pk === payload.pk);
        if (itemIndex !== -1) {
          draft.currentOrder.order_items[itemIndex] = payload;
        }
      }
    }),
  ),
  handle(getOrderItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = payload;
    }),
  ),

  // Обновление товара в заказе
  handle(updateOrderItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.updateItem = true;
      draft.errors.updateItem = null;
    }),
  ),
  handle(updateOrderItemAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.updateItem = false;
      draft.errors.updateItem = null;
      if (draft.currentOrder) {
        const itemIndex = draft.currentOrder.order_items.findIndex(item => item.pk === payload.pk);
        if (itemIndex !== -1) {
          draft.currentOrder.order_items[itemIndex] = payload;
        }
      }
    }),
  ),
  handle(updateOrderItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.updateItem = false;
      draft.errors.updateItem = payload;
    }),
  ),

  // Удаление товара из заказа
  handle(deleteOrderItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.deleteItem = true;
      draft.errors.deleteItem = null;
    }),
  ),
  handle(deleteOrderItemAction.success, (state, { payload: id }) =>
    produce(state, draft => {
      draft.isLoading.deleteItem = false;
      draft.errors.deleteItem = null;
      if (draft.currentOrder) {
        draft.currentOrder.order_items = draft.currentOrder.order_items.filter(
          item => item.pk !== id,
        );
      }
    }),
  ),
  handle(deleteOrderItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.deleteItem = false;
      draft.errors.deleteItem = payload;
    }),
  ),
]);
